export type WorkerTab = "obitelj" | "pregled" | "gradilista" | "podaci" | "dozvole" | "identitet" | "zdravlje" | "znr" | "dokumenti" | "payroll";
const aliases: Record<string, { tab: WorkerTab; part?: string }> = {
  osnovno: { tab: "podaci" },
  oprema: { tab: "znr", part: "oprema" },
  kvalifikacije: { tab: "podaci", part: "kvalifikacije" },
};
export function workerDestination(value: string, part?: string | null): { tab: WorkerTab; part?: string } {
  if (value === "dozvole-identitet") return { tab: part === "identitet" ? "identitet" : "dozvole" };
  if (value === "zdravlje-znr") {
    if (part === "oprema") return { tab: "znr", part: "oprema" };
    return { tab: part === "znr" ? "znr" : "zdravlje" };
  }
  return Object.hasOwn(aliases, value) ? aliases[value]! : { tab: value as WorkerTab };
}
export function legacyWorkerTab(value: string): boolean {
  return Object.hasOwn(aliases, value) || value === "dozvole-identitet" || value === "zdravlje-znr";
}
export function workerDocumentWorkspace(tab: string, part?: string | null): boolean {
  const destination = workerDestination(tab, part);
  return destination.tab === "dokumenti" || destination.tab === "identitet";
}
